import { render, staticRenderFns } from "./faceAvatar.vue?vue&type=template&id=1073c892&scoped=true&"
import script from "./faceAvatar.vue?vue&type=script&lang=js&"
export * from "./faceAvatar.vue?vue&type=script&lang=js&"
import style0 from "./faceAvatar.vue?vue&type=style&index=0&id=1073c892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073c892",
  null
  
)

export default component.exports